const COOKIE_KEY = 'blaze_auth';
const REFRESH_KEY = 'blaze_refresh_token';
const COOKIE_PATH = 'path=/';
const EXPIRED_COOKIE = `${COOKIE_KEY}=;${COOKIE_PATH};expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
const EXPIRY_THRESHOLD = 30;
const NETWORK_ERROR = 'Network error';
const FAILED_TO_FETCH_ERROR = 'Failed to fetch';
// Year in seconds
const COOKIE_EXPIRY_TIME = 31536000;
const VISIBLE_VISIBILITY_STATE = 'visible';
const REFRESHING_TOKEN_KEY = 'blaze_refreshing_token';
const PROVIDER_TYPE_NAME = 'Auth provider';
const REQUIRED_PROPERTIES = [{
  property: 'name',
  type: 'string'
}, {
  property: 'key',
  type: 'string'
}];
const INCLUDE_CREDENTIALS = 'include';
export { COOKIE_KEY, NETWORK_ERROR, REFRESH_KEY, EXPIRED_COOKIE, EXPIRY_THRESHOLD, FAILED_TO_FETCH_ERROR, COOKIE_EXPIRY_TIME, VISIBLE_VISIBILITY_STATE, REFRESHING_TOKEN_KEY, PROVIDER_TYPE_NAME, REQUIRED_PROPERTIES, COOKIE_PATH, INCLUDE_CREDENTIALS };
//# sourceMappingURL=constants.js.map